export class NewFieldOfStudy {
    id: any = null;
    fieldOfStudy: String = '';
}